import PropTypes from 'prop-types';
import { findIndex } from 'lodash';
import { useEffect, useState, useRef, useCallback } from 'react';
//
import Scrollbar from '../../Scrollbar';
import LightboxModal from '../../LightboxModal';
import ChatMessageItem from './ChatMessageItemFacebook';

// ----------------------------------------------------------------------

ChatMessageList.propTypes = {
  conversation: PropTypes.object.isRequired
};

export default function ChatMessageList({ conversation, infoUserSelected, pageCurrent, loadMoreMessage }) {
  const scrollRef = useRef();
  const [openLightbox, setOpenLightbox] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [heightScroll, setHeightScroll] = useState(0);
  useEffect(() => {
    const scrollMessagesToTop = () => {
      if (scrollRef.current && pageCurrent > 1) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight - heightScroll;
        setHeightScroll(scrollRef.current.scrollHeight)
      } else {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        setHeightScroll(scrollRef.current.scrollHeight)
      }
    };
    scrollMessagesToTop();
  }, [conversation]);
  const handleScroll = useCallback(() => {
    if (scrollRef.current.scrollTop === 0 && scrollRef.current.scrollHeight > 500) {
      loadMoreMessage();
    }
  })
  useEffect(() => {
    const div = scrollRef.current;
    div.addEventListener("scroll", handleScroll);
    return () => div.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);
  const images = conversation
    .filter((messages) => messages.type === 'image')
    .map((messages) => messages.attachments[0].payload.url);

  const handleOpenLightbox = (url) => {
    const selectedImage = findIndex(images, (index) => index === url);
    setOpenLightbox(true);
    setSelectedImage(selectedImage);
  };
  return (
    <Scrollbar scrollableNodeProps={{ ref: scrollRef }} sx={{ p: 3, flexGrow: 1 }}>
      {conversation.map((item, index) => (
        <ChatMessageItem
          infoUserSelected={infoUserSelected}
          key={index}
          itemMess={item}
          conversation={conversation}
          onOpenLightbox={handleOpenLightbox}
        />
      ))}

      {/* <LightboxModal
        images={images}
        photoIndex={selectedImage}
        setPhotoIndex={setSelectedImage}
        isOpen={openLightbox}
        onClose={() => setOpenLightbox(false)}
      /> */}
    </Scrollbar>
  );
}
